// Localização: frontend/src/components/Prontuario/Profissional/RH/AvaliacoesSection.jsx (versão 1.0.0)
// Seção de Avaliações de Desempenho do prontuário do profissional

import React, { useState, useEffect } from 'react';
import { Award, Star } from 'lucide-react';
import { getAvaliacoes } from '../../../../api/api';
import { formatDate } from '../../../../utils/formatters';

const AvaliacoesSection = ({ profissionalId, onRefresh }) => {
    const [avaliacoes, setAvaliacoes] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchAvaliacoes();
    }, [profissionalId]);

    const fetchAvaliacoes = async () => {
        try {
            setLoading(true);
            const response = await getAvaliacoes(profissionalId);
            if (response.data.success) {
                setAvaliacoes(response.data.data || []);
            }
        } catch (error) {
            console.error('Erro ao buscar avaliações:', error);
        } finally {
            setLoading(false);
        }
    };

    const getResultadoColor = (resultado) => {
        switch (resultado) {
            case 'excelente':
                return 'bg-green-100 text-green-800';
            case 'bom':
                return 'bg-blue-100 text-blue-800';
            case 'regular':
                return 'bg-yellow-100 text-yellow-800';
            case 'ruim':
            case 'insatisfatorio':
                return 'bg-red-100 text-red-800';
            default:
                return 'bg-gray-100 text-gray-800';
        }
    };

    if (loading) {
        return (
            <div className="text-center py-8">
                <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-teal-600"></div>
            </div>
        );
    }

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Avaliações de Desempenho</h3>

            {avaliacoes.length === 0 ? (
                <div className="text-center py-8 text-gray-500">
                    <Award className="h-12 w-12 mx-auto mb-2 text-gray-400" />
                    <p>Nenhuma avaliação registrada.</p>
                </div>
            ) : (
                <div className="space-y-4">
                    {avaliacoes.map((avaliacao) => (
                        <div
                            key={avaliacao.id}
                            className="border rounded-lg p-4 bg-gray-50 border-gray-200"
                        >
                            <div className="flex justify-between items-start mb-3">
                                <div className="flex items-center space-x-2">
                                    <Award className="h-5 w-5 text-teal-600" />
                                    <span className="font-semibold text-gray-900">
                                        {formatDate(avaliacao.data_avaliacao)}
                                    </span>
                                    <span className={`px-2 py-1 rounded text-xs font-medium ${getResultadoColor(avaliacao.resultado)}`}>
                                        {avaliacao.resultado || 'N/A'}
                                    </span>
                                </div>
                                {avaliacao.nota_geral && (
                                    <div className="flex items-center space-x-1">
                                        <Star className="h-5 w-5 text-yellow-500 fill-current" />
                                        <span className="text-lg font-bold text-gray-900">
                                            {parseFloat(avaliacao.nota_geral).toFixed(1)}
                                        </span>
                                    </div>
                                )}
                            </div>
                            <div className="text-sm text-gray-600 space-y-1">
                                <div>
                                    <span className="font-medium">Tipo:</span> {avaliacao.tipo_avaliacao || 'N/A'}
                                </div>
                                {avaliacao.avaliador_nome && (
                                    <div>
                                        <span className="font-medium">Avaliador:</span> {avaliacao.avaliador_nome}
                                    </div>
                                )}
                                {avaliacao.pontos_fortes && (
                                    <div className="mt-2">
                                        <span className="font-medium">Pontos Fortes:</span>
                                        <p className="text-gray-700 mt-1">{avaliacao.pontos_fortes}</p>
                                    </div>
                                )}
                                {avaliacao.pontos_melhorias && (
                                    <div className="mt-2">
                                        <span className="font-medium">Pontos de Melhoria:</span>
                                        <p className="text-gray-700 mt-1">{avaliacao.pontos_melhorias}</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default AvaliacoesSection;

